import { ObjectsActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const ObjectsReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case ObjectsActionType.Objects_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default ObjectsReducer
